import { Dialog, DialogTitle } from '@mui/material';
import { AIActionForm } from './AIActionForm';
import { useAIAction } from '../../hooks/useAIAction';
import type { AiActionDto } from '../../api/queries/aiActions';

interface Props {
  open: boolean;
  onClose: () => void;
  action: AiActionDto | null;
  contextParams?: Record<string, unknown>;
  onResult?: (result: unknown) => void;
}

export function AIActionDialog({
  open,
  onClose,
  action,
  contextParams,
  onResult,
}: Props) {
  const run = useAIAction(action?.slug ?? '');
  if (!action) return null;

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>{action.name}</DialogTitle>
      <AIActionForm
        schema={action.parametersSchema}
        initialValues={contextParams}
        onCancel={onClose}
        onSubmit={async (params) => {
          const merged = { ...(contextParams ?? {}), ...params };
          const result = await run.mutateAsync(merged);
          onResult?.(result);
          onClose();
        }}
      />
    </Dialog>
  );
}
